export default __webpack_public_path__ + "static/mapViews-7ed94d9f2e9c6bdb848a205a5d0d1077.png";